import React, {useEffect, useState} from 'react'
import styled from '@emotion/styled'
import Professional from './Professional'
import Who from './Who'
import DotsComponent from '../shared/DotsComponent';


const AboutWrapper = styled.div`
    display:grid;
    grid-template-rows: 10rem 90rem;
    
`;
const MainContainer = styled.div`
    position: relative;
    margin-top:5rem;
   
    z-index: 1;
    canvas {
        position: absolute;
        z-index: -1;
        display:none;
    }
`;
const Container = styled.div`
    display:grid;
    grid-gap:1rem;
    grid-auto-flow:column;
    width:20rem;

  

  
`;
const VerticalContainer = styled.div`
    position: relative;
    display:flex;
    height:7.5rem;
    justify-content:space-between;
    flex-direction:column;

    .active{
        color:var(--color-gray-800);
        background-color: var(--color-white);
        font-weight:500;
        cursor:default;
        
    }
    .next--active{
        color:var(--color-gray-800);
        background-color: var(--color-white);
        font-weight:500;
        cursor:default;
        
    }

       
    .active:before{
        position: absolute;
        width: var(--space-8);
        height: var(--space-12);
        top: 2rem;
        right: 9rem;
        content:" ";
        /* default/gray/200 */
       
        background-color: transparent;
        border-radius: 0px 0px var(--space-8) 0px;
        box-shadow: 0px var(--space-6) 0px 0px white;
    }

    .active:after{
        position: absolute;
        width: var(--space-8);
        height: var(--space-12);
        top: 2rem;
        left: 9rem;
        content:" ";
        /* default/gray/200 */

        background-color: transparent;
        border-radius: 0px 0px 0px var(--space-8);
        box-shadow: 0px var(--space-6) 0px 0px white;
    }

    .next--active:before{
        position: absolute;
        width: var(--space-8);
        height: var(--space-12);
        top: 1.6em;
        right: 14rem;
        content:" ";
        /* default/gray/200 */
       
        background-color: transparent;
        border-radius: 0px 0px var(--space-8) 0px;
        box-shadow: 0px var(--space-6) 0px 0px white;
    }

    .next--active:after{
        position: absolute;
        width: var(--space-8);
        height: var(--space-12);
        top: 1.6em;
        left: 14rem;
        content:" ";

        background-color: transparent;
        border-radius: 0px 0px 0px var(--space-8);
        box-shadow: 0px var(--space-6) 0px 0px white;
    }

    @media only screen and (max-width: 500px) {
        .active:before{
        position: absolute;
        width: var(--space-8);
        height: var(--space-12);
        top: 1.6rem;
        right: 7.65rem;
        content:" ";
       
        background-color: transparent;
        border-radius: 0px 0px var(--space-8) 0px;
        box-shadow: 0px var(--space-6) 0px 0px white;
    }

    .active:after{
        position: absolute;
        width: var(--space-8);
        height: var(--space-12);
        top: 1.6rem;
        left: 7.65rem;
        content:" ";

        background-color: transparent;
        border-radius: 0px 0px 0px var(--space-8);
        box-shadow: 0px var(--space-6) 0px 0px white;
    }
    .next--active:before{
        position: absolute;
        width: var(--space-8);
        height: var(--space-12);
        top: 1.8em;
        right: 11.3rem;
        content:" ";
        /* default/gray/200 */
       
        background-color: transparent;
        border-radius: 0px 0px var(--space-8) 0px;
        box-shadow: 0px var(--space-6) 0px 0px white;
    }

    .next--active:after{
        position: absolute;
        width: var(--space-8);
        height: var(--space-12);
        top: 1.8em;
        left: 11.3rem;
        content:" ";

        background-color: transparent;
        border-radius: 0px 0px 0px var(--space-8);
        box-shadow: 0px var(--space-6) 0px 0px white;
    }
    }
`;
const AboutHeader = styled.a`
    position:relative;
    white-space:nowrap;
    cursor:pointer;
    grid-row-start:1;
    padding: var(--space-12) var(--space-16);
    justify-content:center;
    border-radius: var(--space-8) var(--space-8) 0px 0px;
    height: var(--space-44);
    font-weight:500;
    font-size: var(--font-20);
    background-color:var(--company);
    color:var(--color-white);

    @media (max-width:500px){
        font-size: var(--font-14);
    }
`;


const AboutContainer = styled.div`
   
`;
const Header = styled.h1`
    position:relative;
    bottom: 1rem;
    font-family: Inter,sans-serif;
    font-weight: 500;
    font-size: var(--font-40);
    line-height: var(--space-40);
    color:var(--company-dark);

    @media (max-width:500px){
        font-size: var(--font-28)
    }
`;
const AboutInfoContainer = styled.div`
    /* position:absolute; */
    width: inherit;
    margin-top: 5rem;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    @media only screen and (max-width: 500px) {
       justify-content:center;
    }
    @media (max-width: 400px){
      
    }
  
`;

const HeaderBackground = styled.div`
    background: linear-gradient(180deg, #F0F3F4 0%, rgba(255, 255, 255, 0) 100%);
    border-radius: 0px 0px 0px 0px;
    transform: matrix(1, 0, 0, -1, 0, 0);
    width:100%;
    height:12.5rem;
    position:absolute;
    left:0rem;
    z-index:-1;
`;

const Gradient = styled.div`
    position: absolute;
    width: 100%;
    height: 5rem;
    left: 0rem;
    top: 14.75rem;
    z-index:-1;
    background: url(/img/bg.svg);
    transform: matrix(1, 0, 0, -1, 0, 0);
    opacity: 0.35;

    @media (max-width: 768px){
        top: 10.75rem;
    }
`;
const BackgroundContainer = styled.div`
    position: absolute;
    width: 62.5rem;
    height: 56.375rem;
    top: 75%;
    left: 22rem;
    z-index:-1;
    background: linear-gradient(180deg, #F0F3F4 0%, rgba(246, 248, 248, 0) 100%);
    border-radius: var(--space-32) var(--space-32) 0px 0px;

    @media (max-width: 1100px){
        width: 57rem;
        left: 0rem;
        top: 40rem;
    }

    @media (max-width: 768px){
        left: 1rem;
        width: 90vw;
    }
    @media (max-width:500px){
        width: 45rem;
        transform: rotate(-90deg);
        height: 20rem;
        top: 110%;
        left: -10rem;
    }

`;
const About = () => {
    const [page, setPage] = useState(false);
    const [color,setColor] = useState('active');
    const [ncolor,setnColor] = useState('');

    useEffect(() => window.scrollTo(0, 0));
    
    return (
        <AboutWrapper>
            <HeaderBackground/>
            <Gradient/>
            <DotsComponent/>
            {color === 'active' && <BackgroundContainer/>}
            
            <MainContainer>
                <VerticalContainer>
                   
                    <Header>About Us</Header>
                    <Container>
                            
                        <AboutHeader className={color} onClick={()=>{setPage(false);setColor('active');setnColor('')}}>Who We Are</AboutHeader>
                        <AboutHeader className={ncolor} onClick={()=>{setPage(true);setColor('');setnColor('next--active')}}>Medical Professionals</AboutHeader>
                        
                    </Container>
                </VerticalContainer>
            </MainContainer>
            {page == true ? 
                <AboutInfoContainer>
                    <Professional/>
                </AboutInfoContainer>
                :
                <AboutInfoContainer>
                    <Who/>
                </AboutInfoContainer>
            }

        </AboutWrapper>
    )
}

export default About;






